import { useEffect, useState } from "react";
import {
  useFormContext,
  useController,
  ControllerRenderProps,
} from "react-hook-form";
import { useLoadingState } from "../../../../../../providers/SimulationProvider/hooks/useLoadingState";
import { SimulationFormValues } from "../../../../SimulationFormValues";

type DistanceToAdjacentBuildingField = Pick<
  SimulationFormValues,
  "distance_to_adjacent_building"
>;

type Props = {
  value: "0" | "1" | null;
};

type HookReturnType = {
  field: ControllerRenderProps<
    DistanceToAdjacentBuildingField,
    "distance_to_adjacent_building"
  >;
  loading: boolean | undefined;
  hasFieldError: boolean;
  selectedDistanceToAdjacentBuilding: "0" | "1" | null;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const useDistanceToAdjacentBuildingField = ({
  value,
}: Props): HookReturnType => {
  const { control } = useFormContext<DistanceToAdjacentBuildingField>();
  const { field, fieldState, formState } = useController({
    name: "distance_to_adjacent_building",
    control,
  });

  const [
    selectedDistanceToAdjacentBuilding,
    setselectedDistanceToAdjacentBuilding,
  ] = useState<"0" | "1" | null>(null);

  const loading = useLoadingState();

  useEffect(() => {
    setselectedDistanceToAdjacentBuilding(value ?? null);
  }, [value]);

  const hasFieldError =
    // フィールドを操作した後に、フィールドが未入力だった場合
    (fieldState.isTouched && selectedDistanceToAdjacentBuilding === null) ||
    // サブミットボタンが押下された後に、フィールドが未入力だった場合
    (formState.isSubmitted && selectedDistanceToAdjacentBuilding === null);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const value = event.target.value as "0" | "1" | null;
    field.onChange(value);
    setselectedDistanceToAdjacentBuilding(value);
  };

  return {
    field,
    loading,
    hasFieldError,
    selectedDistanceToAdjacentBuilding,
    handleChange,
  };
};
